import { render, staticRenderFns } from "./SelectableMatrixControl.reg.vue?vue&type=template&id=74a37162&"
import script from "./SelectableMatrixControl.reg.vue?vue&type=script&lang=ts&"
export * from "./SelectableMatrixControl.reg.vue?vue&type=script&lang=ts&"
import style0 from "./SelectableMatrixControl.reg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VContainer,VInput,VRow})
